import { Component, ChangeDetectionStrategy } from '@angular/core';
import { IToolPanelAngularComp } from 'ag-grid-angular';
import { IRowNode, IToolPanelParams } from 'ag-grid-community';
import { MatIcon } from '@angular/material/icon';
import { NgFor, NgStyle } from '@angular/common';

@Component({
	selector: 'app-custom-stats-tool-panel',
	templateUrl: './funding-list-tool-panel.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./funding-list-tool-panel.component.scss'],
	imports: [MatIcon, NgFor, NgStyle],
})
export class FundingListToolPanelComponent implements IToolPanelAngularComp {
	public params!: IToolPanelParams | any;

	public summaryData!: any;

	agInit(params: IToolPanelParams | any): void {
		this.params = params;

		this.params.api.addEventListener(
			'modelUpdated',
			this.updateTotals.bind(this)
		);
	}

	updateTotals(): void {
		this.params.api.forEachNode((rowNode: IRowNode) => {
			const data = rowNode.data;
		});

		this.summaryData = {};
	}

	refresh(): void {}
}
